module.exports = __webpack_public_path__ + "img/image-culture-4.1237cd12.png";